import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchOrganizations, deleteOrganizations } from '../services/userOrganizations';
import { toast } from 'react-toastify';

// Hook to fetch organizations with pagination and search
export const useFetchOrganizations = (currentPage, search, sortedBy) => {
    return useQuery({
        queryKey: ['organizations', { currentPage, search, sortedBy }],
        queryFn: fetchOrganizations,
        cacheTime: 5 * 60 * 1000, // Cache data for 5 minutes
        staleTime: 0, // Data becomes stale immediately for refetching if required
    });
};

// Hook to delete an organization
export const useDeleteOrganization = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteOrganizations,
        onSuccess: (response) => {
            if (response.status === 200 || response.status === 201) {
                toast.success(response?.data?.message || 'Organization deleted successfully.');
                queryClient.invalidateQueries(['organizations']); // Refetch organizations on successful deletion
            }
        },
        onError: () => {
            toast.error('Error deleting organization.');
        },
    });
};
